import Dialog from "../../atoms/dialog";
import DeleteSimulationTestsuite from "../simulations/DeleteSimulationTestsuite";

const DeleteSimulationTestsuiteAlert = ({ onClose, onCompletion, element }) => {
    console.log("------DeleteSimulationTestsuiteAlert-----")
    console.log({element})
    console.log({onClose})

    const handleClose = () => {
        onClose();
    }

    return (
        <Dialog
            open={true}
            handleClose={handleClose}
            paperProps={{ id: "deleteTestsuteModal" }}
            title={"Delete"}

        >
            <DeleteSimulationTestsuite onClose={handleClose} onCompletion={onCompletion} element={element} />
        </Dialog >
    )
}

export default DeleteSimulationTestsuiteAlert;